import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

const AdminGuard = ({ children }) => {
  const { status } = useAuth();
  if (status === "checking") {
    return (
      <div className="min-h-screen bg-[#faf7ee] text-[#6b6356] flex items-center justify-center">
        Loading…
      </div>
    );
  }
  if (status === "guest") return <Navigate to="/admin/login" replace />;
  return children;
};

export default AdminGuard;
